export const MIN_LEN = 0.5
export const EPSILON = 1e-6
// Clips closer than this on a track count as touching
export const ADJACENT_GAP = 0.01
export const LANE_HEIGHT = 60
export const HEAD_WIDTH = 140
export const DEFAULT_VIEW_SECONDS = 300
export const DEFAULT_IMAGE_SECONDS = 5
export const IMAGE_MAX_SECONDS = 3600
export const FRAME_ASPECT = 16 / 9
export const FADE_MIN = 0.1
export const FADE_MAX = 10
